class Video {
  constructor() {
    const videoThumbnail = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
    const playButton = Array.prototype.slice.call(document.querySelectorAll('.ns-video__playbutton'));
    videoThumbnail.forEach(thumbnail => {
      const background = thumbnail.style.backgroundImage;
      if (background === '') {
        thumbnail.style.display = 'none';
      }
    });
    playButton.forEach(button =>{
      button.addEventListener('click', () => {
        const video = button.parentElement.parentElement;
        const thumbnail = button.parentElement;
        const iframe = video.querySelector('video');
        iframe.play();
        button.style.display = 'none';
        thumbnail.style.display = 'none';
      });
    });
  }
} export default Video;
